<div id="dashboardContainer">
  <div class="row">
    @if (!applicationService.initialized) {
      <div class="col-md">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      <router-outlet #children></router-outlet>
    }
  </div>
</div>
<!-- asdf -->
